import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LeaveMasterService } from '../../../Model/leave-master.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { NavigationExtras, Router } from '@angular/router';
import { Session } from 'inspector';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-leave-view',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, NgbPaginationModule, DataTablesModule],
  templateUrl: './leave-view.component.html',
  styleUrl: './leave-view.component.scss'
})
export class LeaveViewComponent {
  dtTrigger: Subject<any> = new Subject<any>();
  LeaveMasterData: any[] = [];
  LeaveMasterID: any;
  public User: any = null;
  dtoptions: DataTables.Settings = {};
  constructor(private leaveService: LeaveMasterService,
    private sessionService: SessionService,
    private router: Router,
    protected common: CommonService,
    private tooltip: TooltipService,
    private toast: ToastService,
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.getData();
  }
  getData() {
    this.User = this.sessionService.GetUserDetails();
    const LeaveGetData = {
      SelectType: 1,
      LeaveMasterId: 0,
      UserId: this.User.UserId
    }
    this.leaveService.LeaveMasterSelect(LeaveGetData).subscribe(
      data => {
        this.LeaveMasterData = Object.values(data.Table);
        this.dtTrigger.next(null);
      },
      error => {
        console.error('Error:', error);
      }
    );
  }
  onEditClick(element: any): void {
    if (this.common.PageRight.IsEdit) {
      this.LeaveMasterID = element.LeaveMasterID;
      let navigationID: NavigationExtras = {
        queryParams: {
          LeaveMasterID: this.LeaveMasterID
        }
      };
      this.router.navigate(['master/LeaveForm'], navigationID);
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  excelDownload(){
    this.common.ExcelDump('Leave', this.LeaveMasterData);
  }
}
